// @flow

import * as React from 'react';

import {
  selectCartIsWorking,
  selectCartIsActive,
  type ProductId,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Badge, Base } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import AlphabetSelect, {
  type Props as AlphabetSelectProps,
} from './AlphabetSelect';
import LabelContent from './LabelContent';

export type Props = {
  disabledOption: boolean,
  value?: AlphabetSelectProps['value'],
  onChange: AlphabetSelectProps['onChange'],
  /** productId is used to generate a unique field id */
  productId: ProductId,
};

export default function AlphabetRow({
  value,
  onChange,
  disabledOption,
  productId,
}: Props): React.MixedElement {
  const working = useAppSelector(selectCartIsWorking);
  const active = useAppSelector(selectCartIsActive);
  const { __ } = useTranslator();

  const inputId = `alphabet-${productId}`;

  return (
    <Base flex flexShrink0 gap="xsmall" marginBottom="xsmall">
      <LabelContent htmlFor={inputId} label={__('Choose alphabet')}>
        <Base flex gap="xsmall" flexAlignItemsCenter>
          <AlphabetSelect
            id={inputId}
            disabled={disabledOption || working}
            readOnly={!active}
            onChange={onChange}
            value={value}
          />
          {!value && <Badge intent="warning">{__('Missing')}</Badge>}
        </Base>
      </LabelContent>
    </Base>
  );
}
